import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { IneligibleFundingClientsView } from '../components/views/ineligibleFundingClientsView'

function IneligibleFundingClients() {
    return (
        <div className="ineligibleFundingClients">
            <Sidebar />
            <MainView>
                <IneligibleFundingClientsView />
            </MainView>
        </div>
    )
}

export default IneligibleFundingClients
